import React from "react"; const Footer = () => <footer className="bg-gray-900 text-white py-8"><div className="text-center">© 2025 Mirchi Republic Media Production</div></footer>; export default Footer;
